<div class="calculator-container" id="roi-calculator">
    <div class="calculator-header">
        <h3>Calculateur de Dette Technique & ROI</h3>
        <p>Ajustez les curseurs pour estimer le coût réel de vos bugs et interruptions de service.</p>
    </div>

    <div class="calculator-grid">
        <!-- INPUTS -->
        <div class="inputs-section">
            <div class="input-group">
                <label>Bugs / Tickets par mois</label>
                <input type="number" [(ngModel)]="bugsPerMonth" (ngModelChange)="calculate()" min="0">
                <span class="hint">Moyenne mensuelle</span>
            </div>
            
            <div class="input-group">
                <label>Temps moy. résolution (h)</label>
                <input type="number" [(ngModel)]="resolutionTime" (ngModelChange)="calculate()" min="0.5" step="0.5">
                <span class="hint">Heures par ticket</span>
            </div>

            <div class="input-group">
                <label>Coût horaire dev (€)</label>
                <input type="number" [(ngModel)]="devHourlyRate" (ngModelChange)="calculate()" min="20" step="10">
                <span class="hint">Salaire chargé / Freelance</span>
            </div>

            <div class="input-group">
                <label>Indisponibilité (min/mois)</label>
                <input type="number" [(ngModel)]="downtimeMinutes" (ngModelChange)="calculate()" min="0">
                <span class="hint">Downtime total mensuel</span>
            </div>

            <div class="input-group full-width">
                <label>Impact CA par heure d'arrêt (€)</label>
                <input type="number" [(ngModel)]="revenueLostPerHour" (ngModelChange)="calculate()" min="0" step="100">
                <span class="hint">Chiffre d'affaires perdu si le service est down</span>
            </div>

            <!-- CTA Replacement -->
            <div class="cta-wrapper full-width">
                 <a href="https://cal.mesh-box.fr/ogirodin/30min" target="_blank" class="btn-calculate primary">
                    Demander un Diagnostic
                </a>
            </div>
        </div>

        <!-- RESULTS (Always visible now) -->
        <div class="results-section visible">
            <div class="results-content">
                <div class="kpi-grid">
                    <div class="kpi bad">
                        <span class="label">Coût Actuel / an</span>
                        <span class="value">{{ currentMonthlyCost * 12 | currency:'EUR':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="kpi good">
                        <span class="label">Économies Est. / an</span>
                        <span class="value">+{{ annualSavings | currency:'EUR':'symbol':'1.0-0' }}</span>
                    </div>
                </div>

                <div class="chart-container">
                    <div class="bar-group">
                        <div class="bar-fill bad" [style.height.%]="barCurrentHeight"></div>
                        <span class="bar-label">Actuel</span>
                    </div>
                    <div class="bar-group">
                        <div class="bar-fill good" [style.height.%]="barOptimizedHeight"></div>
                        <span class="bar-label">Optimisé</span>
                    </div>
                </div>
                
                <div class="analysis-text">
                    <p>
                        En réduisant la dette technique, vous pourriez économiser 
                        <strong>{{ annualSavings | currency:'EUR':'symbol':'1.0-0' }} par an</strong> 
                        et libérer <strong>{{ (bugsPerMonth * resolutionTime) * 0.4 | number:'1.0-0' }} heures</strong> de développement par mois.
                    </p>
                </div>

                <a href="https://cal.mesh-box.fr/ogirodin/30min" target="_blank" class="btn-cta-result">
                    Arrêter l'hémorragie →
                </a>
            </div>
        </div>
    </div>
</div>